import config from "@/config";
import axios from 'axios';

export default {
    namespaced: true,

    state: () => ({
        //
    }),

    getters: {
        //
    },

    mutations: {
        setMisc(state, data) {
            data.forEach(e => {
                state[e.key] = e.value;
            });

            state.loaded = true;
        },
    },

    actions: {
        async createRoom({}, data) {
            return await axios.post(`${config.SOCKET_API_URL}/room/create`, data);
        },

        async joinRoom({}, data) {
            return await axios.post(`${config.SOCKET_API_URL}/room/verify`, data);
        },
    }
};
